import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { usePageView } from './hooks/usePageView'

import HomePage from './pages-public/HomePage'
import BlogListPage from './pages-public/BlogListPage'
import BlogPostPage from './pages-public/BlogPostPage'
import CaseListPage from './pages-public/CaseListPage'
import CaseDetailPage from './pages-public/CaseDetailPage'
import SitemapPage from './pages-public/SitemapPage'

import AdminLayout from './components-admin/AdminLayout'
import LoginPage from './pages-admin/LoginPage'
import DashboardPage from './pages-admin/DashboardPage'
import BlogListPageAdmin from './pages-admin/BlogListPage'
import BlogEditorPage from './pages-admin/BlogEditorPage'
import CasesListPageAdmin from './pages-admin/CasesListPage'
import CaseEditorPage from './pages-admin/CaseEditorPage'
import SettingsPage from './pages-admin/SettingsPage'

function RequireAuth({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="flex items-center justify-center min-h-screen bg-[#0d1f12] text-white">Carregando...</div>
  if (!user) return <Navigate to="/admin/login" replace />
  return children
}

function App() {
  usePageView()
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<HomePage />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/cases" element={<CaseListPage />} />
      <Route path="/cases/:slug" element={<CaseDetailPage />} />
      <Route path="/sitemap.xml" element={<SitemapPage />} />

      {/* Admin */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="blog" element={<BlogListPageAdmin />} />
        <Route path="blog/new" element={<BlogEditorPage />} />
        <Route path="blog/edit/:id" element={<BlogEditorPage />} />
        <Route path="cases" element={<CasesListPageAdmin />} />
        <Route path="cases/new" element={<CaseEditorPage />} />
        <Route path="cases/edit/:id" element={<CaseEditorPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  )
}

export default App
